function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 4.625C15.7321 4.91964 15.4286 5.17857 15.1071 5.40179C13.6161 6.41071 12.1161 7.42857 10.6607 8.48214C9.91072 9.03571 8.98214 9.71429 8.00893 9.71429H8H7.99107C7.01786 9.71429 6.08929 9.03571 5.33929 8.48214C3.88393 7.41964 2.38393 6.41071 0.901786 5.40179C0.571429 5.17857 0.267857 4.91964 0 4.625V11.7143C0 12.5 0.642857 13.1429 1.42857 13.1429H14.5714C15.3571 13.1429 16 12.5 16 11.7143V4.625ZM16 2C16 1.21428 15.3482 0.571428 14.5714 0.571428H1.42857C0.473214 0.571428 0 1.32143 0 2.19643C0 3.00893 0.901786 4.01786 1.53571 4.44643C2.91964 5.41071 4.32143 6.375 5.70536 7.34821C6.28571 7.75 7.26786 8.57143 7.99107 8.57143H8H8.00893C8.73214 8.57143 9.71429 7.75 10.2946 7.34821C11.6786 6.375 13.0804 5.41071 14.4732 4.44643C15.2589 3.90178 16 3 16 2Z",
  fill: "white"
});

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.488b33e3.svg";
export { ForwardRef as ReactComponent };